// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Add, Edit, Update, Approve, Delete
// MODIFIED DATE : 20-08-2025

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/*************** ADD BUSINESS LOAN PROPOSAL START ***************/
export const createNewBusinessLoan = (addData: any) => {
	const data = {
		BusinessLoanProposalToken: addData,
	};
	const url = `${API_URL}createBusinessLoanProposal`;
	return makeApiCall(url, data);
};
/*************** ADD BUSINESS LOAN PROPOSAL END ***************/

/*************** UPDATE BUSINESS LOAN PROPOSAL START ***************/
export const updateBusinessLoan = (updateData: any) => {
	const data = {
		BusinessLoanProposalUpdateToken: updateData,
	};
	const url = `${API_URL}updateBusinessLoanProposal`;
	return makeApiCall(url, data);
};
/*************** UPDATE BUSINESS LOAN PROPOSAL END ***************/

/*************** GET BUSINESS LOAN PROPOSAL LIST START ***************/
export const businessLoanProposalListFetch = (listData: any) => {
	const data = {
		GetBusinessLoanProposalListToken: listData,
	};
	const url = `${API_URL}getBusinessLoanProposalList`;
	return makeApiCall(url, data);
};
/*************** GET BUSINESS LOAN PROPOSAL LIST END ***************/

/*************** APPROVE BUSINESS PROPOSAL START ***************/
export const businessLoanProposalApprove = (approveData: any) => {
	const data = {
		BusinessLoanProposalApprovalToken: approveData,
	};
	const url = `${API_URL}businessLoanProposalApprove`;
	return makeApiCall(url, data);
};
/*************** APPROVE BUSINESS PROPOSAL END ***************/

/*************** FETCH BUSINESS LOAN PROPOSAL START ***************/
export const businessLoanProposalDetailsFetch = (fetchData: any) => {
	const data = {
		FetchBusinessLoanProposalDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchBusinessLoanProposalDetail`;
	return makeApiCall(url, data);
};
/*************** FETCH BUSINESS LOAN PROPOSAL END ***************/

/*************** DELETE BUSINESS LOAN PROPOSAL START ***************/
export const businessLoanProposalDelete = (deleteData: any) => {
	const data = {
		BusinessLoanProposalDeleteToken: deleteData,
	};
	const url = `${API_URL}deleteBusinessLoanProposal`;
	return makeApiCall(url, data);
};
/*************** DELETE BUSINESS LOAN PROPOSAL END ***************/
